const i="div[role=dialog]{position:absolute;top:0;left:0;z-index:9999;visibility:hidden;opacity:0;transition:opacity .2s}";export{i as default};
